import { render } from "./StoryReader.vue?vue&type=template&id=42a984b7"
import script from "./StoryReader.vue?vue&type=script&lang=js"
export * from "./StoryReader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__